import React, { FC, memo, useContext } from 'react'
import { ThemeContext } from 'styled-components'

import { HowItWorksStepTransport } from '@common/transports/deprecated-home-page-transport'
import {
    HowItWorksStepCardContainer,
    HowItWorksStepContainer,
    NumberedDotContainer,
    DottedLine,
} from './how-it-works-step-styles'
import { NumberedDot } from './numbered-dot'
import HowItWorksStepCard from './how-it-works-step-card'

interface Props {
    step: HowItWorksStepTransport
    stepNumber: number
    isFirstStep: boolean
    isLastStep: boolean
    isLoggedIn: boolean
}

const HowItWorksStep: FC<Props> = ({ step, stepNumber, isFirstStep, isLastStep, isLoggedIn }) => {
    const theme = useContext(ThemeContext)
    return (
        <HowItWorksStepContainer>
            <NumberedDotContainer>
                <DottedLine color={isFirstStep ? 'transparent' : theme.colors.tfwBlack12} marginLeft="-0.234375rem" />
                <NumberedDot number={stepNumber} fillColor={theme.colors.tfwRed} />
                <DottedLine color={isLastStep ? 'transparent' : theme.colors.tfwBlack12} marginRight="-0.234375rem" />
            </NumberedDotContainer>
            <HowItWorksStepCardContainer>
                <HowItWorksStepCard step={step} isLoggedIn={isLoggedIn} />
            </HowItWorksStepCardContainer>
        </HowItWorksStepContainer>
    )
}

export default memo(HowItWorksStep)
